import { createSelector } from '@reduxjs/toolkit';

import {
  hasAssemblyPermission,
  isChMachineUser,
  isDemoOrganizationUser,
  isG2User,
  isTrussWorksUser,
} from '@paragon/login-tools';

import { isLayoutModeEnabled } from './layoutModeSelectors';

export const getHeaderText = createSelector(
  isLayoutModeEnabled,
  isG2User,
  isTrussWorksUser,
  isDemoOrganizationUser,
  isChMachineUser,
  hasAssemblyPermission,
  (
    layoutModeEnabled,
    useG2Theme,
    useTrussWorksTheme,
    useDemoTheme,
    useCHTheme,
    hasAssemblyPermission,
  ): string | null => {
    if (useG2Theme) return 'G2 National';

    if (useTrussWorksTheme) return 'TrussWorks';

    if (useDemoTheme) return 'Building Industry Partners';

    if (useCHTheme) return null;

    if (hasAssemblyPermission && !layoutModeEnabled) return 'Paragon Assembly';

    return 'Paragon';
  },
);
